import { render } from "./PeopleView.vue?vue&type=template&id=44f8345a&scoped=true"
import script from "./PeopleView.vue?vue&type=script&lang=js"
export * from "./PeopleView.vue?vue&type=script&lang=js"

import "./PeopleView.vue?vue&type=style&index=0&id=44f8345a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f8345a"]])

export default __exports__